import { Component, ElementRef, HostListener, effect, inject, viewChild } from '@angular/core';
import { ConfirmService } from '../../core/confirm';

/**
 * Único diálogo de confirmación del panel. Se monta una sola vez en la raíz y muestra lo que
 * pida `ConfirmService.ask()`.
 *
 * No se cierra al hacer click afuera, igual que el resto de los modales: la respuesta tiene
 * que ser explícita. `Escape` sí cancela — es la salida sin consecuencias, y es lo que hacía
 * el `confirm()` del navegador.
 */
@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  templateUrl: './confirm-dialog.html',
  styleUrl: './confirm-dialog.scss',
})
export class ConfirmDialog {
  protected confirm = inject(ConfirmService);

  private confirmButton = viewChild<ElementRef<HTMLButtonElement>>('confirmButton');

  constructor() {
    // El botón aparece recién cuando hay una pregunta abierta; enfocarlo hace que Enter
    // confirme y Tab quede dentro del diálogo.
    effect(() => this.confirmButton()?.nativeElement.focus());
  }

  @HostListener('document:keydown.escape')
  onEsc() {
    if (this.confirm.pending()) this.confirm.resolve(false);
  }
}
